import { useRef, forwardRef, useCallback } from 'react';
import { useVirtualizer } from '@tanstack/react-virtual';
import VirtualizedListView from '../virtualizedListView';
import OverlayScrollbarsHost from '../overlayScrollbarsHost';
import {
  baseVirtualizedListPropTypes,
  virtualizerConfigPropTypes,
} from '../propTypes';

const ContainerVirtualizedList = forwardRef((props, ref) => {
  const {
    count,
    gap,
    estimateSize,
    getItemKey,
    virtualizerRef,
    overlayWrapperClass,
    verticalScrollClass,
    horizontalScrollClass,
    ...viewProps
  } = props;

  const rootRef = useRef(null);
  const viewportRef = useRef(null);
  const vScrollbarSlotRef = useRef(null);
  const hScrollbarSlotRef = useRef(null);

  const virtualizer = useVirtualizer({
    getScrollElement: useCallback(() => viewportRef.current, []),
    getItemKey,
    overscan: 5,
    count,
    gap,
    estimateSize,
  });

  return (
    <VirtualizedListView
      {...viewProps}
      ref={ref}
      virtualizer={virtualizer}
      virtualizerRef={virtualizerRef}
      usesExternalScroll={false}
      viewportRef={viewportRef}
      scrollWrapper={OverlayScrollbarsHost}
      scrollWrapperProps={{
        rootRef,
        viewportRef,
        vScrollbarSlotRef,
        hScrollbarSlotRef,
        overlayWrapperClass,
        verticalScrollClass,
        horizontalScrollClass,
      }}
    />
  );
});

ContainerVirtualizedList.displayName = 'ContainerVirtualizedList';

ContainerVirtualizedList.propTypes = {
  ...baseVirtualizedListPropTypes,
  ...virtualizerConfigPropTypes,
};

export default ContainerVirtualizedList;
